import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-brand-guarantee border-y-4 border-brand-green" data-id="element-177">
      <div className="max-w-4xl mx-auto text-center" data-id="element-178">
        <ShieldCheckIcon className="w-24 h-24 text-brand-green mx-auto mb-6" data-id="element-179" />

        <h2 className="text-4xl md:text-5xl font-black text-brand-dark mb-8 uppercase" data-id="element-180">
          🛡️ GARANTÍA SIN VUELTAS — 7 DÍAS
        </h2>

        <div className="text-xl md:text-2xl text-gray-800 space-y-4 font-medium mb-12 max-w-3xl mx-auto" data-id="element-181">
          <p data-id="element-182">
            Estamos tan seguros de que este sistema te va a cambiar la forma de
            trabajar que te damos 7 días completos para probarlo sin riesgo.
          </p>
          <p className="font-bold text-brand-dark" data-id="element-183">
            Si en 7 días no te convence:
          </p>
          <p className="text-3xl font-black text-brand-green py-4" data-id="element-184">
            Te devolvemos el 100% de tu dinero.
          </p>
          <p data-id="element-185">Sin preguntas. Sin vueltas. Así de simple.</p>
          <p className="text-lg text-gray-600 mt-6" data-id="element-186">
            Comprás sin riesgo. La única forma de perder es no intentarlo.
          </p>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-187">
          <CTAButton text="→ EMPEZAR HOY CON GARANTÍA" href="#compra" data-id="element-188" />
        </div>
      </div>
    </section>;
}